import { Light, LightApi } from '@/types/Light';
import { Vector3 } from 'three';

export class LightMapper {
    private static properties: Array<keyof LightApi> = ['color', 'intensity', 'matrix', 'type'];

    static getLightFromData(lightData: LightApi): Light {
        LightMapper.checkLightData(lightData);

        const { color, intensity, type, layers, matrix, shadow, uuid, ...rest } = lightData;
        const position = new Vector3(...matrix?.slice(12, 15)) ?? new Vector3(0, 0, 0);

        const light: Light = {
            color: color ?? '#ffffff',
            intensity: intensity ?? 1,
            type: type || 'AmbientLight',
            // NE PAS passer layers comme prop - laisse THREE.js gérer
            // layers: { mask: layers ?? 1 },  // ❌ Écrasait THREE.Layers
            ...rest,
            position
        };

        return light;
    }

    private static checkLightData(lightData: LightApi): void {
        this.properties.forEach((property) => {
            if (lightData[property] == null) {
                console.error(`Property ${property} is missing or undefined in this light: ${lightData.uuid}`);
            }
        });
    }
}
